import { createFileRoute } from '@tanstack/react-router'
import { AdminBadgeCopyPage } from '@/features/policy/pages/admin-badge-copy-page'

export const Route = createFileRoute('/badge-copy')({
  staticData: { title: 'Badge copy' },
  component: AdminBadgeCopyPage,
})
